import React from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by the Saco Lowell Meadows Ring Twister machine

export default function TravelerSizeSacoRow({ minProp = 1, maxProp = 3 }) {
   const { handleInputRangeChange, onChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const traveler1 = machineSetup.extendedPropertyJson?.traveler1 || false;
   const traveler2 = machineSetup.extendedPropertyJson?.traveler2 || false;
   const traveler3 = machineSetup.extendedPropertyJson?.traveler3 || false;
   const traveler4 = machineSetup.extendedPropertyJson?.traveler4 || false;

   const travelerQty1 = machineSetup.extendedPropertyJson?.travelerQty1 || "";
   const travelerQty2 = machineSetup.extendedPropertyJson?.travelerQty2 || "";
   const travelerQty3 = machineSetup.extendedPropertyJson?.travelerQty3 || "";
   const travelerQty4 = machineSetup.extendedPropertyJson?.travelerQty4 || "";

   const defaultOnChangeVal = { target: { value: "" } };

   return (
      <>
         <Row className="mb-2 mt-3">
            <ColPrompt
               title={
                  <span>
                     Traveler Size
                     <br />
                     {"(Check all that apply)"}
                  </span>
               }
               bold={true}
               description={""}
               sizeProp={3}
            />
            <ColValue size={6}>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler1}
                                 onChange={() => onChange("extendedPropertyJson.traveler1", !traveler1)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; J-232-C LT. GREEN
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="text-end fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type={"text"}
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty1}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty1", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty1", true)
                              }
                              disabled={!traveler1}
                           />
                           {errorDivDefinitions?.["travelerQty1"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler2}
                                 onChange={() => onChange("extendedPropertyJson.traveler2", !traveler2)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; J-192-C RED
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty2}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty2", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty2", true)
                              }
                              disabled={!traveler2}
                           />
                           {errorDivDefinitions?.["travelerQty2"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler3}
                                 onChange={() => onChange("extendedPropertyJson.traveler3", !traveler3)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; J-467-C NAT
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty3}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty3", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty3", true)
                              }
                              disabled={!traveler3}
                           />
                           {errorDivDefinitions?.["travelerQty3"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler4}
                                 onChange={() => onChange("extendedPropertyJson.traveler4", !traveler4)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; J-73-C NAT
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty4}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty4", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty4", true)
                              }
                              disabled={!traveler4}
                           />
                           {errorDivDefinitions?.["travelerQty4"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </ColValue>
         </Row>
      </>
   );
}
